import { Color, Spacing } from '@persona-id/design-tokens';
import { ComponentPropsWithoutRef, FC } from 'react';
import styled from 'styled-components';

import Button from 'design-system/components/Button';
import { FontWeight } from 'design-system/variables/text';

interface TabSwitchProps {
  selected?: boolean;
  disabled?: boolean;
}

const StyledTab = styled(Button)<TabSwitchProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  white-space: no-wrap;
  background-color: ${({ selected }) => (selected ? 'white' : Color.CoreSlate50)};
  font-weight: ${FontWeight.Regular};

  margin-left: ${Spacing[2]};
  margin-top: ${Spacing[2]};
  margin-bottom: ${Spacing[2]};

  &:last-of-type {
    margin-right: ${Spacing[2]};
  }

  height: ${Spacing[6]};
`;

const TabSwitch: FC<TabSwitchProps & ComponentPropsWithoutRef<typeof StyledTab>> = ({
  selected,
  disabled,
  children,
  ...elemProps
}) => {
  return (
    <StyledTab
      type='button'
      role='tab'
      variant='basic'
      selected={selected}
      aria-selected={selected}
      aria-disabled={disabled}
      {...elemProps}
    >
      {children}
    </StyledTab>
  );
};

export default TabSwitch;
